import styled from 'styled-components';

import GenericDataGrid from '../../../../components/GenericDataGrid';
import colors from '../../../../../styles/colors';

const BLOCKED_ROW_CLASS = 'row-blocked';

const StyledDataGrid = styled(GenericDataGrid)`
  .${BLOCKED_ROW_CLASS} {
    color: ${colors.shades.secondary6};
    background-color: ${colors.shades.secondary10};
  }
`;

const StatusCell = styled.span`
  color: ${({ $isBlocked }) => ($isBlocked ? colors.shades.danger3 : colors.shades.secondary8)};
`;

const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
  font-size: 14px;
  color: ${colors.shades.secondary6};
`;

const Summary = styled.span`
  font-size: 12px;
  color: ${colors.shades.secondary8};
`;

export {
  BLOCKED_ROW_CLASS,
  StyledDataGrid,
  StatusCell,
  EmptyState,
  Summary,
};
